import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import moment from 'moment';

import ContactCollection from 'collections/contact';
import ContactView from 'views/contact';


export default Backbone.View.extend({
  initialize: function (options) {
    _.bindAll(this, 'render', 'new_message');

    this.template = _.template($('#contact-list-tmpl').html());

    // Override moment calendar formatting
    moment.locale('en', {
      calendar: {
        lastDay: '[Yesterday]',
        sameDay: 'LT',
        lastWeek: '[Last] dddd',
        sameElse: 'M/D/YYYY'
      }
    });

    this.coachhub = options.coachhub;
    this.profile_message_view = this.coachhub.profile_message_view;
    this.collection = this.coachhub.contacts;
    this.collection.on('remove', this.render);
    this.render();

    this.coachhub.on('new-message', this.new_message);
  },

  render: function () {
    // This function is idempotent. You can call it whenever you want,
    // as often as you want and it will rerender the contact list with
    // the current collection (which should always be accurate)
    this.$el.html(this.template({ contacts: this.collection }));
    this.collection.each(function (contact) {
      new ContactView({
        model: contact,
        coachhub: this.coachhub,
        el: $('#contact-' + contact.get('user').id, this.$el)
      });
    }, this);
    this.profile_message_view.render();
  },

  new_message: function (data) {
    // If the the message is to or from someone in the list, fetch the
    // latest information on that contact and rerender
    var msg = data.message;
    var ids = [ msg.author_id, msg.recipient_id ];
    var contact = this.collection.find(function (model) {
      return _.contains(ids, model.get('user').id);
    });
    if (contact) {
      contact.fetch({ success: _.bind(function (model) {
        this.collection.sort();
        // TODO: Reorder existing DOM elements rather than rerendering
        this.render();
      }, this) });
    } else {
      // This must be a new contact. Refresh the whole collection.
      this.collection.fetch({ success: this.render });
    }
  }
});



// WEBPACK FOOTER //
// ./static/js/views/contact_list.js